<template>
  <el-dialog
  title="异常申请记录"
  :visible.sync="show"
  :before-close="close"
  center>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    indexKey="申请编号"
    >
      <template #index/>
      <template #operate={row}>
        <el-button class="tableBtn" @click="see(row)" type="text" size="small">查看详情</el-button>
        <el-button class="tableBtn" @click="update(row)" type="text" size="small" v-if="row.status == 2 || row.status === 10">修改</el-button>
        <el-button class="tableBtn" @click="approval(row)" type="text" size="small" v-if="row.status == 0">催批</el-button>
      </template>
    </table-list>
  </el-dialog>
</template>

<script>
import TableList from '@/components/TableList.vue'
import { compApplyAttendanceQuery, sendSmsAuditPersonAgain } from '@/api/compAttendance.js'
import { ApprovalStatus } from '@/utils/constants'

export default {
  data () {
    return {
      show: false,
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      columnDefs: [
        // { label: '申请编号', prop: 'eventId' },
        { label: '申请时间', prop: 'createTime' },
        {
          label: '当前审核人',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        {
          label: '审核状态',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '操作', prop: 'operate' }
      ]
    }
  },
  components: {
    TableList
  },
  methods: {
    close () {
      this.show = false
      this.ListData = []
    },
    showDialog () {
      this.show = true
      this.query()
    },
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      compApplyAttendanceQuery({
        pageNum: this.page,
        pageSize: this.pageSize
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    see (row) {
      console.log(row)
      this.$emit('showDetails', row.id)
    },
    update (row) {
      this.$emit('update', row.id)
    },
    async approval(row) {
      this.$confirm('此操作将进行催批, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await sendSmsAuditPersonAgain(params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '催批成功!' })
        }
        await this.getData()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 700px;
  width: 30%;
}
</style>
